import { Stack } from '@fluentui/react';
import { forwardRef, HTMLAttributes, Ref } from 'react';

import { IComponent } from '../../models/components.models';
import { useClassNames } from '../../utils/hooks';
import { ClipboardButton } from '../ClipboardButton/ClipboardButton';
import { DownloadButton } from '../DownloadButton/DownloadButton';
import {
  codeBlockButtonContainerStyles,
  codeBlockButtonStyles,
  codeBlockStylesDefault,
  ICodeBlockStyles,
} from './CodeBlock.styles';

interface ICodeBlockClassNames {
  root: string;
  pre: string;
}

export interface ICodeBlockProps extends IComponent<ICodeBlockStyles>, HTMLAttributes<HTMLPreElement> {
  children: React.ReactNode;
  serializedContent?: string;
  showCopyButton?: boolean;
  downloadFilename?: string;
}

export const CodeBlock = forwardRef((props: ICodeBlockProps, ref: Ref<HTMLPreElement>) => {
  const { className, children, downloadFilename, serializedContent, showCopyButton, styles, ...rest } = props;

  const classNames = useClassNames<ICodeBlockStyles, ICodeBlockClassNames>(
    'CodeBlock',
    codeBlockStylesDefault,
    styles,
    className
  );
  const contentAsString = serializedContent
    ? serializedContent
    : typeof children === 'string'
    ? children
    : JSON.stringify(children);

  const renderButtonContainer = showCopyButton || downloadFilename;

  return (
    <div className={classNames.root}>
      {renderButtonContainer && (
        <Stack horizontal styles={codeBlockButtonContainerStyles} tokens={{ childrenGap: 8 }}>
          {downloadFilename && (
            <DownloadButton styles={codeBlockButtonStyles} content={contentAsString} filename="requirements.txt" />
          )}
          {showCopyButton && <ClipboardButton styles={codeBlockButtonStyles} content={contentAsString} />}
        </Stack>
      )}
      <pre ref={ref} className={classNames.pre} {...rest}>
        <code>{children}</code>
      </pre>
    </div>
  );
});
